import * as React from 'react'
import * as PropTypes from 'prop-types'
import { css } from 'glamor'

import { isKey } from '../../utils'
import { useTheme } from '../../theme'

import getStyles from './styles'

const variants = ['positive', 'negative', 'alert', 'dim', 'normal', 'link', 'white']

interface ITextPlaceholderProps {
  variant: 'positive' | 'negative' | 'alert' | 'dim' | 'normal' | 'link' | 'white'
  size: number
}

export function TextPlaceholder({ variant, size }: ITextPlaceholderProps) {
  const styles = getStyles(useTheme())

  return (
    <span
      {...css(
        styles.placeholder.base,
        isKey(styles.placeholder.variants, variant) && styles.placeholder.variants[variant],
        { width: `${size}ch` }
      )}
    >
      <span
        {...css(styles.shimmer.base, isKey(styles.shimmer.variants, variant) && styles.shimmer.variants[variant])}
      />
    </span>
  )
}

TextPlaceholder.displayName = 'TextPlaceholder'

TextPlaceholder.propTypes = {
  variant: PropTypes.oneOf(variants),
  size: PropTypes.number,
}

TextPlaceholder.defaultProps = {
  variant: 'normal',
  size: 20,
}

TextPlaceholder.VARIANTS = variants
